
import React from 'react';
import Simulations from '../../components/Simulations/Simulations';
import InteractiveSimulations from '../../components/Simulations/InteractiveSimulations';
import { Tab } from '@hydrodigital/design-system';
const SimulationsView: React.FC = () => {
  const security = localStorage.getItem('security');
  const userData = security ? JSON.parse(security) : null;
  const modules = userData?.modules || [];
  const showInteractiveSimulation = modules.findIndex((m: any) => m.id == 10) >= 0;

  const tabs = [
    ...(showInteractiveSimulation
      ? [{ label: 'INTERACTIVE', id: '1', content: <InteractiveSimulations /> }]
      : []),
    { label: 'SCHEDULED', id: '2', content: <Simulations /> },
  ];

  const [selectedTab, setSelectedTab] = React.useState(tabs[0].id);


  return (
    <div>
      <div className="text-title-page mb-3">Simulation Status</div>
      <div className="text-subtitle-page mb-3">
        Check the status of the forecast simulation engine
      </div>
      <Tab
        activeTab={selectedTab}
        showContent
        orientation="horizontal"
        tabs={tabs}
        onTabChange={(id) => {
					setSelectedTab(id);
				}}
      />
    </div>
  );
};

export default SimulationsView;
